export default "__VITE_ASSET__9VVQ$McX__"